import React from "react";
import { Create, SimpleForm, NumberInput } from "react-admin";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { validatePositiveNumber2 } from "../../utils/Validations";
import CreateToolbar from "../Custom/create-save-button";

const useStyles = makeStyles({
  container: {
    width: "100%",
  },
});

const PreciousInlayPricingCreate = (props) => {
  const classes = useStyles();

  return (
    <Create {...props} className="overflow-visible">
      <SimpleForm toolbar={<CreateToolbar />}>
        <Grid container className={classes.container} spacing={2}>
          <Grid item xs={12} sm={6}>
            <NumberInput
              source="quantity"
              label="Quantity"
              validate={[validatePositiveNumber2]}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumberInput
              source="width"
              label="Width"
              validate={[validatePositiveNumber2]}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumberInput
              source="volume_delta"
              label="Volume Delta"
              validate={[validatePositiveNumber2]}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumberInput
              source="labor"
              label="Labor"
              validate={[validatePositiveNumber2]}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumberInput
              source="silver_markup"
              label="Silver Markup"
              validate={[validatePositiveNumber2]}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumberInput
              source="10k_markup"
              label="10k Markup"
              validate={[validatePositiveNumber2]}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumberInput
              source="14k_markup"
              label="14k Markup"
              validate={[validatePositiveNumber2]}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumberInput
              source="18k_markup"
              label="18k Markup"
              validate={[validatePositiveNumber2]}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumberInput
              source="platinum_markup"
              label="Platinum Markup"
              validate={[validatePositiveNumber2]}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumberInput
              source="palladium_markup"
              label="Palladium Markup"
              validate={[validatePositiveNumber2]}
              fullWidth
              required
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};

export default PreciousInlayPricingCreate;
